<!-- =========================================================================================
  File Name: Profile.vue
  Description: Profile Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
    <form action>
      <div class="vx-row mb-6">
        <div class="vx-col md:w-1/2 w-full ql-container">
          <h3 class="pt-3">Add/Edit Privacy Policies in HTML</h3> 
          <vs-textarea
            v-validate="'required'"
            class="ql-container color"
            rows="22"
            placeholder="Insert text here"
            v-model="content"
            :color="validateForm ? 'success' : 'danger'"
          />
          <div class="p-4">
            <vs-button @click="submitData" class="w-full" :disabled="!validateForm"> Submit </vs-button>
          </div>
        </div>
        <div class="vx-col md:w-1/2 w-full">
          <h3 class="pt-3">View Privacy Policies App</h3>
          <div class="output" v-html="content"></div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
import DataProvider from "../../services/data-provider";

export default {
  data() {
    return {
      editorOption: {
        modules: {
          toolbar: ["code-block"],
        },
        theme: "snow", // or 'bubble'
      },
      content: ``,
    };
  },
  methods: {
    submitData() {
      this.$vs.loading();
      DataProvider.postDataToCloud("/privacy_policies", {
        app_policy: this.content,
      }).then((data) => {
        console.log("data", data);
        this.$vs.loading.close();
      },err=>{
        this.$vs.loading.close();
        if (err.message.includes("403")) {
                this.$vs.notify({
                  color: "warning",
                  title: "Access denied!",
                });
              }
      });
    },
    getData() {
      this.$vs.loading();
      DataProvider.getDataFromCloud("/privacy_policies").then((data) => {
        console.log("getDataFromCloud:", data);
        if (data.data) this.content = data.data.app_policy;
        this.$vs.loading.close();
      },err=>{
        DataProvider.sendSentryErrorLog(err)
      });
    },
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.content!="";
    },
  },
  mounted() {
    this.getData();
  },
  components: {
    quillEditor,
  },
  beforeDestroy() {
    // if (!this.wasSidebarOpen) this.$store.commit("TOGGLE_REDUCE_BUTTON", false);
  },
};
</script>


<style lang="scss">
.ql-container {
  min-height: 500px;
}
.color{
    background: #fff;


}
.output {
  //   margin-top: 10px;
  border: 1px solid #e8e8e8;
  min-height: 500px;
  padding: 10px;
  background: #fff;
}
// @import "@/assets/scss/vuexy/pages/profile.scss";
</style>
